import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { RoleCardData } from "../data/mockRoles";
import "./DeleteRoleModal.scss";

export interface DeleteRoleModalProps {
  open: boolean;
  role: RoleCardData | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteRoleModal: React.FC<DeleteRoleModalProps> = ({
  open,
  role,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open && Boolean(role)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="delete-role-modal"
      PaperProps={{
        sx: {
          borderRadius: "10px",
          boxShadow: "0px 12px 32px rgba(15, 23, 42, 0.18)",
          maxWidth: 480,
          overflow: "hidden",
        },
      }}
    >
      {role ? (
        <div className="delete-role-modal__shell">
          <header className="delete-role-modal__header">
            <div className="delete-role-modal__title-icon" aria-hidden>
              <span className="delete-role-modal__title-icon-badge">
                <Iconography
                  icon="circleExclamation"
                  size={IconographySizes.Small}
                />
              </span>
            </div>
            <h2 className="delete-role-modal__title">Delete Role?</h2>
          </header>

          <DialogContent className="delete-role-modal__body">
            <p className="delete-role-modal__lead">
              Are you sure to delete{" "}
              <strong className="delete-role-modal__role-name">
                &quot;{role.name}&quot;
              </strong>
              . This action cannot be undone and will remove this role for all
              portal.
            </p>

            <div className="delete-role-modal__warning" role="alert">
              <Iconography
                icon="circleExclamation"
                size={IconographySizes.Medium}
                className="delete-role-modal__warning-icon"
              />
              <div className="delete-role-modal__warning-copy">
                <p className="delete-role-modal__warning-title">
                  Warning notification
                </p>
                <p className="delete-role-modal__warning-text">
                  Roles currently assigned to this role will no longer have access
                  to it.
                </p>
              </div>
            </div>
          </DialogContent>

          <footer className="delete-role-modal__footer">
            <Button variant="tertiary" label="CANCEL" onClick={onClose} />
            <Button variant="primary" label="DELETE" onClick={onConfirm} />
          </footer>
        </div>
      ) : null}
    </Dialog>
  );
};

export default DeleteRoleModal;
